import { HttpClient } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { ConfigOptions, ConfigService } from '@wilson/config';
import { Permissions } from '@wilson/interfaces';
import { Observable } from 'rxjs';

@Injectable()
export class PermissionsService {
  private readonly httpClient = inject(HttpClient);
  private readonly config = inject<ConfigOptions>(ConfigService);

  getUserPermissions(userId: string): Observable<Permissions> {
    return this.httpClient.get<Permissions>(
      `${this.config.host}/users/${userId}/permissions`,
      {
        headers: {
          'X-Application': this.config.application,
        },
      },
    );
  }
}
